import GroupedListReducer from '../GroupedListReducer.js';
const resourceUser = GroupedListReducer.create({
  name: 'temporaryUser',
  idKey: 'username',
  idActionKey: 'userId',
  constantPrefix: 'api.resourceTemporaryUser',
  itemKey: 'user',
  itemsKey: 'items',
  defaultStateKey: 'resourceTemporaryUsers'
});
export default resourceUser;